﻿import Helpers from "./helpers";

export default class ShowContent {

	private triggers: NodeListOf<HTMLButtonElement>;

	constructor() {
		this.init();
	}

	public init() {

		this.triggers = document.querySelectorAll('.js-show-content');

		if (!this.triggers.length) return;

		this.triggerClicks();

	}

	private triggerClicks() {


		for (let i = 0; i < this.triggers.length; i++) {

			this.triggers[i].addEventListener('click', (e) => {


				const eventTarget = e.target as HTMLLinkElement;
				const targetContent = document.querySelector('#' + eventTarget.getAttribute('aria-controls'));

				Helpers.removeElement(eventTarget);
				targetContent.setAttribute('aria-hidden', 'false');
				targetContent.classList.remove('u-hide');

			});

		}

	}

}
